import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  documents: {
    error: null,
    loading: false,
    documents: [],
    quoteId: null,

  },
};

export const paidQuotesSlice = createSlice({
  name: 'paidQuotes',
  initialState,
  reducers: {
    quotationDocumentsPending: (state) => {
      state.documents.loading = true;
      state.documents.error = null;
    },
    quotationDocumentsRejected: (state, { payload }) => {
      state.documents.loading = false;
      state.documents.error = payload;
    },
    quotationDocumentsSuccess: (state, { payload }) => {
      state.documents.loading = false;
      state.documents.documents = payload.data.data.documents;
      state.documents.quoteId = payload.data.data.quotation_id;
    },

  },
});
